import React, { useRef, useState } from 'react';
import { Box, Stack, TableBody, TableCell, TableRow } from '@mui/material';
import axios from 'axios';
import Create from './Create';
import { UpdateButton } from '../../../../components/common/button/CustomButtons';
import ChildHeader from '../../../../components/ui/ChildHeader';
import {
  CustomPagination,
  PersitedDatePicker,
  TableCustom,
} from '../../../../components/common';
import useDebounce from '../../../../hooks/useDebounce';
import {
  AddIconButton,
  DeleteIconButton,
  ViewIconButton,
} from '../../../../components/common/button/CustomIconButton';
import ModalCustom from '../../../../components/common/Modal';
import { useQuery } from '../../../../hooks/UseQuery';
import useConfirm from '../../../../components/common/useConfirm';
import { apiConstant, checkListList } from '../constant';
import formatDate from '../../../../components/common/formatDate';
import CustomUploadButton from '../../../../components/common/button/CustomUploadButton';
import ViewFile from './ViewFile';
import { useNavigate } from 'react-router-dom';
import ProcessProductAuditStatus from './components/processProductAuditStatus';
import TableScroll from '../../../../components/ui/renderTable/TableScroll';

const tableHeaderObj = [
  [
    { text: 'S. NO.', rowspan: 1, colspan: 1, style: { minWidth: '80px' } },
    { text: 'PART NAME', rowspan: 1, colspan: 1, style: { minWidth: '150px' } },
    { text: ' DUE DATE', rowspan: 1, colspan: 1, style: { minWidth: '100px' } },
    {
      text: 'LAST  DATE',
      rowspan: 1,
      colspan: 1,
      style: { minWidth: '100px' },
    },
    {
      text: 'STATUS',
      rowspan: 1,
      colspan: 1,
      style: { minWidth: '150px' },
    },
    {
      text: 'ATTACH PROOF',
      rowspan: 1,
      colspan: 1,
      style: { minWidth: '150px' },
    },
    {
      text: 'PROCESS AUDIT CHECKLIST',
      rowspan: 1,
      colspan: 1,
      style: { minWidth: '140px' },
    },
    {
      text: 'AUDIT CHECKLIST',
      rowspan: 1,
      colspan: 1,
      style: { minWidth: '140px' },
    },
    {
      text: 'SUBPART 1',
      rowspan: 1,
      colspan: 1,
      style: { minWidth: '100px' },
    },
    {
      text: 'SUBPART 2',
      rowspan: 1,
      colspan: 1,
      style: { minWidth: '100px' },
    },
    // {
    //   text: 'SUBPART 3',
    //   rowspan: 1,
    //   colspan: 1,
    //   style: { minWidth: '100px' },
    // },
    // {
    //   text: 'SUBPART 4',
    //   rowspan: 1,
    //   colspan: 1,
    //   style: { minWidth: '100px' },
    // },
    // {
    //   text: 'SUBPART 5',
    //   rowspan: 1,
    //   colspan: 1,
    //   style: { minWidth: '100px' },
    // },
    // {
    //   text: 'SUBPART 6',
    //   rowspan: 1,
    //   colspan: 1,
    //   style: { minWidth: '100px' },
    // },
    // {
    //   text: 'SUBPART 7',
    //   rowspan: 1,
    //   colspan: 1,
    //   style: { minWidth: '100px' },
    // },
    // {
    //   text: 'SUBPART 8',
    //   rowspan: 1,
    //   colspan: 1,
    //   style: { minWidth: '100px' },
    // },
    // {
    //   text: 'SUBPART 9',
    //   rowspan: 1,
    //   colspan: 1,
    //   style: { minWidth: '100px' },
    // },
    // {
    //   text: 'SUBPART 10',
    //   rowspan: 1,
    //   colspan: 1,
    //   style: { minWidth: '100px' },
    // },
    {
      text: 'ACTION',
      rowspan: 1,
      colspan: 1,
      style: { minWidth: '160px' },
    },
  ],
];

const getCurrentStatus = (status: any) => {
  const statusMap: any = {
    overdue: [{ bgColor: '#e03131', width: '300px', text: ' OVERDUE' }],
    pending: [{ bgColor: '#fcc419', width: '300px', text: ' NOT STARTED' }],
    started: [{ bgColor: '#5c7cfa', width: '300px', text: ' ONGOING' }],
    completed: [{ bgColor: '#2f9e44', width: '300px', text: 'COMPLETED' }],
  };

  const [{ bgColor, text, width }] = statusMap[status] || [];
  return bgColor ? (
    <TableCell align="center" style={{ backgroundColor: bgColor, width }}>
      {text}
    </TableCell>
  ) : null;
};

const List = () => {
  const [data, setData] = useState<any[]>([]);
  const [render, setRender] = useState(false);
  const [perPage, setPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState(0);
  const search = useQuery('search') || '';
  const date = useQuery('date');
  const idRef = useRef<any>({});
  const [isOpenFiles, setIsOpenFiles] = useState(false);
  const page = useQuery('page') || 1;
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [DialogDelete, confirmDelete] = useConfirm(
    'DELETE',
    'Are you sure you want to delete this?',
  );
  const [listId, setListId] = useState('');
  const [docFiles, setDocFiles] = useState<any>({});
  const fetchData = async () => {
    const res = await axios
      .get(
        `/api/${apiConstant.getAllCheckList}/${date}/?page=${page}&search=${search}&perPage=${perPage}`,
      )
      .catch((err) => {
        console.log(err);
      });
    setData(res?.data?.results);
    setPerPage(res?.data?.perPage);
    setTotalPages(res?.data?.pages);
  };

  const handleDelete = async (item: any) => {
    const ans = await confirmDelete();
    if (!ans) return;
    await axios
      .put(
        `/api/${apiConstant.checkListStatus}/${item.docId}/${item._id}/${item.month}`,
        {
          p: false,
          isTask: false,
          doneDate: null,
          status: 'pending',
        },
      )
      .then((res) => {
        alert('Document deleted successfully');
        setRender((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };

  useDebounce(fetchData, 500, [
    page,
    search,
    date,
    isOpenPopup,
    render,
    isOpenFiles,
  ]);
  const uploadFile = async (e: any, item: any) => {
    if (!window.confirm('Are you sure you want upload this Files')) return;
    const files = e.target.files;
    if (!files) return;
    let formData = new FormData();
    for (const key of Object.keys(files)) {
      formData.append('files', files[key]);
    }
    setIsLoading(true);

    axios
      .patch(
        `/api/${apiConstant.checklistUpload}/${item.docId}/${item._id}/${item.month}`,
        formData,
      )
      .then((res) => {
        if (res.data) {
          alert('document upload successly');
          setIsLoading(false);
          setRender((prev) => !prev);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };
  return (
    <>
      <ChildHeader text={`${checkListList.childHeader}`}></ChildHeader>
      <Box sx={{ margin: 2 }}>
        <PersitedDatePicker
          label={`${checkListList.datePickerLabel}`}
          views={['year', 'month']}
        />
      </Box>
      <TableScroll>
        <TableCustom tableHeaderObj={tableHeaderObj}>
          <TableBody>
            {data?.length > 0 &&
              data.map((item: any, index: number) => (
                <React.Fragment>
                  <TableRow>
                    <TableCell align="center">
                      {perPage * (+page - 1) + index + 1}
                    </TableCell>
                    <TableCell align="center">{item?.a1_part_no}</TableCell>
                    <TableCell align="center">{item?.dueDate}</TableCell>
                    <TableCell align="center">
                      {formatDate(item.doneDate)}
                    </TableCell>
                    {getCurrentStatus(item?.status)}
                    <TableCell align="center">
                      <Stack direction="row" sx={{ justifyContent: 'center' }}>
                        <CustomUploadButton
                          accept="image/png,image/jpeg,image/jpg,application/pdf"
                          id={`${index}_files_`}
                          multiple={true}
                          onChange={(e) => {
                            uploadFile(e, item);
                          }}
                        />
                        {item.files?.length > 0 && (
                          <>
                            <ViewIconButton
                              tooltipTitle="view"
                              onClick={() => {
                                idRef.current = {
                                  docId: item.docId,
                                  _id: item._id,
                                  month: item.month,
                                };
                                setDocFiles(item.files);
                                setIsOpenFiles(true);
                              }}
                            />
                          </>
                        )}
                      </Stack>
                    </TableCell>
                    <TableCell align="center">
                      <Stack
                        direction="row"
                        sx={{ justifyContent: 'center', alignItems: 'center' }}
                      >
                        {item.checklist_id ? (
                          <ViewIconButton
                            tooltipTitle="Modify Checklist"
                            onClick={() => {
                              navigate(
                                `${'/common/productAuditPlanOldChecklistCreate'}/${item?.checklist_id}?part_name=${item?.a1_part_name}&part_no=${item?.a1_part_no}&dueDate=${item.dueDate}&documentId=${item?.docId}&listItemObjectId=${item._id}&month=${item?.month}&isView=false`,
                              );
                            }}
                          />
                        ) : (
                          <AddIconButton
                            tooltipTitle="Edit Checklist"
                            onClick={() => {
                              navigate(
                                `${'/common/productAuditPlanOldChecklistCreate'}?part_name=${item?.a1_part_name}&part_no=${item.a1_part_no}&dueDate=${item.dueDate}&documentId=${item?.docId}&listItemObjectId=${item._id}&month=${item?.month}&isView=false`,
                              );
                            }}
                          />
                        )}

                        {item.checklist_id ? (
                          <div
                            style={{
                              background: '#51cf66',
                              borderRadius: '50%',
                              width: '20px',
                              height: '20px',
                            }}
                          ></div>
                        ) : (
                          <div
                            style={{
                              opacity: '0',
                              borderRadius: '50%',
                              width: '20px',
                              height: '20px',
                            }}
                          ></div>
                        )}
                      </Stack>
                    </TableCell>
                    <ProcessProductAuditStatus
                      letter={'a1'}
                      {...{ item }}
                      tooltip="Audit Checklist"
                    />
                    <ProcessProductAuditStatus
                      letter={'a2'}
                      {...{ item }}
                      tooltip="Subpart 1"
                    />
                     <ProcessProductAuditStatus
                      letter={'a3'}
                      {...{ item }}
                      tooltip="Subpart 2"
                    />
                    {/*
                    <ProcessProductAuditStatus
                      letter={'a4'}
                      {...{ item }}
                      tooltip="Subpart 3"
                    />
                    <ProcessProductAuditStatus
                      letter={'a5'}
                      {...{ item }}
                      tooltip="Subpart 4"
                    />
                    <ProcessProductAuditStatus
                      letter={'a6'}
                      {...{ item }}
                      tooltip="Subpart 5"
                    />
                    <ProcessProductAuditStatus
                      letter={'a7'}
                      {...{ item }}
                      tooltip="Subpart 6"
                    />
                    <ProcessProductAuditStatus
                      letter={'a8'}
                      {...{ item }}
                      tooltip="Subpart 7"
                    />
                    <ProcessProductAuditStatus
                      letter={'a9'}
                      {...{ item }}
                      tooltip="Subpart 8"
                    />
                    <ProcessProductAuditStatus
                      letter={'a10'}
                      {...{ item }}
                      tooltip="Subpart 9"
                    />
                    <ProcessProductAuditStatus
                      letter={'a11'}
                      {...{ item }}
                      tooltip="Subpart 10"
                    /> */}
                    <TableCell>
                      <Stack direction="row" sx={{ justifyContent: 'center' }}>
                        <DeleteIconButton
                          tooltipTitle="DELETE"
                          onClick={() => {
                            handleDelete(item);
                          }}
                        />
                        <UpdateButton
                          label="update"
                          sx={{ margin: '10px' }}
                          size="small"
                          onClick={() => {
                            setListId(item);
                            setIsOpenPopup(true);
                          }}
                        />
                      </Stack>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
          </TableBody>
        </TableCustom>
      </TableScroll>
      <ModalCustom
        title={`${checkListList.modalTile}`}
        openModal={isOpenPopup}
        closeModal={() => {
          setIsOpenPopup(false);
          setListId('');
        }}
      >
        <Create setIsModal={setIsOpenPopup} item={listId} />
      </ModalCustom>
      <ModalCustom
        title="FILE LIST"
        openModal={isOpenFiles}
        closeModal={() => {
          setIsOpenFiles(false);
        }}
      >
        <ViewFile
          id={idRef.current}
          docFiles={docFiles}
          setIsOpenFiles={setIsOpenFiles}
        />
      </ModalCustom>
      <CustomPagination totalPage={totalPages} />
      <DialogDelete isSubmitContent={false} />
    </>
  );
};

export default List;
